import styled from '@emotion/styled';
import { media } from '../../services/media';

export const Heading = styled.h2`
    margin-bottom: 27px;

    ${media.min('md')} {
        max-width: 315px;
    }

    ${media.min('lg')} {
        padding-top: 100px;
    }

    ${media.min('xl')} {
        max-width: 460px;
    }

    ${media.min('xxl')} {
        max-width: 810px;
        font-size: 84px;
        margin-bottom: 66px;
        padding-top: 300px;
    }
`;
